import { Theme } from '@mui/material'

import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()((theme: Theme) => ({
  receivedResaleAuths: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdownAndProduct: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: theme.spacing(3),
    marginBottom: theme.spacing(2),
    alignItems: 'center',
  },
  emptyResaleState: {
    marginBottom: theme.spacing(4),
  },
  emptyResaleStateContent: {
    marginBottom: theme.spacing(3),
  },
  waitText: {
    color: 'green',
  },
  upperContainter: {
    display: 'flex',
    flexDirection: 'row',
  },
  justifySpaceBetween: {
    justifyContent: 'space-between',
  },
}))
